import React from 'react';

export default class Page11 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToDevelopStrategicLongTermGoals');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p> Now that you have considered the factors involved in
                                                developing successful strategies and long-term goals and
                                                have some
                                                practical tools to consider, it’s worth thinking about what
                                                to do next. Here are a number of suggestions (although these
                                                are
                                                by no means exhaustive):</p>

                                            <div className="border_subtitle">Develop operational plan</div>
                                            <p>Write a rough plan of the resources, budget and timing that
                                                you need to make the strategy happen. This doesn’t have to
                                                be
                                                precise but should be as accurate as you can forecast.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think about the opportunities you have in your current work,
                                                or outside of your existing remit where you can support or
                                                lead on developing strategic long-term goals.</p>

                                            <div className="border_subtitle">Implement the advice</div>
                                            <p>Try and implement some of the advice or practical tools
                                                outlined in this document when next developing a
                                                strategy.</p>

                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find and it useful to consider your current strengths
                                                and development needs for creating visions and strategic
                                                planning.
                                                Benchmarking your current performance by asking for formal
                                                or informal feedback will help you understand where you need
                                                most
                                                support hereafter, and may help others around you recognise
                                                your approach and needs.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>FURTHER INFORMATION
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then
                                                you are likely to find the following tools both insightful
                                                and relevant:</p></div>
                                            <div className="indicatorlist_new">
                                                <ul className="greenbullet-list sept further_bullet_spacing">
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToThinkAboutProblemsLaterally')}
                                                           className="link_color thought button-link-redirect">How to think about
                                                            problems laterally</div>
                                                    </li>
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToFormulateActionPlans')}
                                                           className="link_color thought button-link-redirect">How to formulate
                                                            action plans</div>
                                                    </li>
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToCommunicateYourVision')}
                                                           className="link_color thought button-link-redirect">How to communicate
                                                            your vision</div>
                                                    </li>
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToBeInnovative')}
                                                           className="link_color thought button-link-redirect">How to be
                                                            innovative</div>
                                                    </li>
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}
                                                           className="link_color thought button-link-redirect">How to focus on
                                                            the bigger picture</div>
                                                    </li>
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToMakeEthicalDecisions')}
                                                           className="link_color thought button-link-redirect">How to make
                                                            ethical decisions</div>
                                                    </li>
                                                    <li>
                                                        <div onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}
                                                           className="link_color thought button-link-redirect">How to balance
                                                            risk with potential benefits.</div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>References
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Read, D. &amp; van
                                                    Leeuwen, B. (1998). Predicting Hunger: The Effects of
                                                    Appetite and Delay on Choice.

                                                    <strong>Organizational Behavior and Human Decision
                                                        Processes,</strong>
                                                    76(2), 189-205.</p>
                                                </li>
                                                <li><p className="further_info_content">Loewenstein, G.,
                                                    O'Donoghue, T. &amp; Rabin, M. (2003). Projection Bias
                                                    In Predicting Future Utility.<strong>
                                                        Quarterly

                                                        Journal of Economics
                                                    </strong>
                                                    , 118(4),1209-1248.</p></li>
                                                <li><p className="further_info_content">Johnson,
                                                    G. &amp; Scholes, K.R.W. (2006).
                                                    <strong> Exploring Corporate Strategy </strong>
                                                    , Prentice Hall.</p></li>
                                                <li><p className="further_info_content">Doran, George T.
                                                    (1981), There's a S.M.A.R.T Way to Write Management
                                                    Goals and Objectives,<strong> Management Review</strong>
                                                    <strong>
                                                        (AMA Forum).</strong></p></li>

                                            </ol>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page10')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn"><a
                                                onClick={this._savePageStatus('Thought')}
                                                className="button-next-previous-done thought">Done</a></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}